import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { baseButtonStyles } from './LytBaseButton';
const StyledPrimaryButton = styled.button.withConfig({
    shouldForwardProp: (prop) => !['isCompact', 'isIconOnly'].includes(prop),
})`
    ${baseButtonStyles}

    background-color: ${({ theme }) =>
        theme.components.lyt_button.primary.background.default};
    color: ${({ theme }) => theme.components.lyt_button.primary.text.default};

    &:not(:disabled):hover {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.primary.background.hover};
        color: ${({ theme }) => theme.components.lyt_button.primary.text.hover};
    }

    &:not(:disabled):active {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.primary.background.pressed};
        color: ${({ theme }) =>
            theme.components.lyt_button.primary.text.pressed};
    }

    &:focus-visible {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.primary.background.focus};
        outline: 2px solid
            ${({ theme }) => theme.components.lyt_button.primary.border.focus};
        outline-offset: 1px;
    }

    &:disabled {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.primary.background.disabled};
        color: ${({ theme }) =>
            theme.components.lyt_button.primary.text.disabled}4D;
    }

    &.lyt-button-selected {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.primary.background.selected};
        color: ${({ theme }) =>
            theme.components.lyt_button.primary.text.selected};

        &:hover {
            background-color: ${({ theme }) =>
                theme.components.lyt_button.primary.background.selected};
            color: ${({ theme }) =>
                theme.components.lyt_button.primary.text.selected};
        }
    }
`;
const LytPrimaryButton = ({ isCompact = false, ...props }) => {
    return <StyledPrimaryButton isCompact={isCompact} {...props} />;
};
LytPrimaryButton.propTypes = {
    isCompact: PropTypes.bool,
};
export default LytPrimaryButton;
